'use client'
import {
  FindUniqueToSeePublicDocumentQueryVariables,
  useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery,
  useFindUniqueToSeePublicDocumentLazyQuery,
} from '@/graphql/generated/graphql'
import Actions from '../components/Actons'
import Captcha from '../components/Captcha'
import Header from '../components/Header'
import Summary from '../components/Summary'
import Table from '../components/Table'
import ViewOther from '../components/ViewOther'
import { NotFoundComponent } from '@/components/NotFound'
import Card from '@/components/Card'
import { setTheme, useViewTheme } from '../theme'
import { cn } from '@/utils/style'
import Loading from '@/components/Loading'
import { useApolloSideEffectOnCompleted } from '@/hooks/useApolloSideEffectOnCompleted'

const ConditionalHeader = () => {
  const theme = useViewTheme()

  if (!theme) return null

  return <Header />
}

export default function PublicViewCodeTemplate() {
  const theme = useViewTheme()
  const [get, { data }] = useFindUniqueToSeePublicDocumentLazyQuery({})
  const { loading: loadingTheme, data: themeData } =
    useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery({
      skip: Boolean(theme),
    })

  useApolloSideEffectOnCompleted(
    themeData?.findUniqueTeamAndPublicDocumentBaseTypeByPublicUrl,
    (data) => {
      if (data?.team) {
        setTheme(data)
      }
    },
  )

  if (loadingTheme) return <Loading />

  const item = data?.findUniqueToSeePublicDocument
  console.log({ item })

  if (item === null)
    return (
      <div className="bg-slate-50 w-full h-screen">
        <ConditionalHeader />
        <div
          className={cn({
            'pt-20': !theme,
            'pt-4': theme,
          })}
        >
          <Card className="font-medium text-slate-700 max-w-6xl p-8 flex gap-4 flex-col text-center mx-auto">
            <NotFoundComponent
              subtitle={`Não encontramos seu documento na nossa base de dados.`}
            />
          </Card>
        </div>
      </div>
    )

  if (!item)
    return (
      <div>
        <ConditionalHeader />
        <Captcha
          onTokenResponse={async (token) => {
            const res = await get({
              variables: {
                recaptchaResponse: token,
              } satisfies FindUniqueToSeePublicDocumentQueryVariables,
            })
          }}
        />
      </div>
    )

  return (
    <div className="bg-gray-50 w-full">
      <Header />
      <div
        className="font-medium text-slate-700 max-w-6xl mx-auto"
        style={{ minHeight: `calc(100vh - 67px)` }}
      >
        <Summary publicViewFields={item} />
        <Actions publicViewFields={item} />
        <Table publicViewFields={item} />
        <div className="px-4 lg:px-0 max-w-6xl mx-auto md:hidden flex mt-2">
          <ViewOther className="w-full" />
        </div>
      </div>
    </div>
  )
}
